import { lazy } from 'react';
import { useOutlet } from 'react-router';

import { RegionalApiFactoryContext, RegionalApisContext } from '@/context/RegionScope';

/**
 * Loads the food, meal and staff API clients for every route except the queue. The queue shell
 * only needs the data-review client, and evaluating the others was most of the startup script time.
 */
export const FullRegionalApis = lazy(async () => {
  const { canadaApis, createRegionalApis } = await import('@/apiClients/regionalApis');
  const Layout = () => {
    const outlet = useOutlet();
    return (
      <RegionalApiFactoryContext.Provider value={createRegionalApis}>
        <RegionalApisContext.Provider value={canadaApis}>{outlet}</RegionalApisContext.Provider>
      </RegionalApiFactoryContext.Provider>
    );
  };
  return { default: Layout };
});
